import { API_V4 } from "@/services/config/auth-axios";

class MarketService {
  getAvailableMarketList() {
    return API_V4.get("/markets");
  }
  getBaseCurrencies() {
    return API_V4.get("/markets/base-currencies");
  }

  getMarketTimes() {
    return API_V4.get("/markets/market-times");
  }
}

export default new MarketService();
